<template>
  <div class="ft">
    <router-link
      class="lc"
      :class="elink && 'active'"
      v-if="BI == 'magzplus'"
      to="/elink"
      >電子書
    </router-link>
    <span v-else class="lc">雜誌列表</span>
    <span
      @click.prevent="changeLcid(location)"
      v-for="location in lcids"
      :key="location.key"
      class="lc actable"
      :class="!elink && currentLcid == location.key && 'active'"
      >{{ location.title }}</span
    >
  </div>
</template>

<script>
import { lcids } from "../libs/consts";
export default {
  props: ["elink"],
  data() {
    return {
      lcids,
      currentLcid: sessionStorage.getItem("lcid") || "1028",
      BI: process.env.VUE_APP_BI,
    };
  },
  methods: {
    changeLcid(lc) {
      this.currentLcid = lc.key;
      sessionStorage.setItem("lcid", lc.key);
      this.$emit("changelcid", { lcid: lc.key });
      if (this.$route.path !== "/") this.$router.push("/");
    },
  },
};
</script>

<style  scoped>
.ft {
  display: flex;
  position: fixed;
  bottom: 0;
  align-items: center;
  align-self: center;
  flex-direction: row;
  justify-content: center;
  box-shadow: 1px 0px 1px rgba(132, 132, 132, 0.25);
  background-color: #f1f1f1;
  height: 0.8rem;
  overflow: hidden;
  z-index: 10;
  width: 100%;
}

.lc {
  width: 1.5rem;
  text-align: center;
  text-decoration: none;
  line-height: 0.8rem;
  height: 0.8rem;
  letter-spacing: 0px;
  white-space: nowrap;
  color: #777777;
  font-size: 0.22rem;
  box-sizing: border-box;
  display: inline-block;
}

/* .lc:first-child:hover {
  border-bottom: none;
  color: #777777;
} */

.active {
  font-weight: 500;
  border-bottom: 0.06rem solid #115fad;
  color: #115fad;
}
</style>
